import React from "react";
import { useChatOpen, useSharedChat } from "../../../../hooks/useAgentContext";

/**
 * Renders a help icon next to a field that triggers the AI assistant to explain
 * the field (and, for enums, the currently selected option). Shown only when the
 * backend marks the field with `ai_explainable=true`. Works for every field type.
 */
export default function FieldExplainButton({ field, name }: { field: any; name?: string }) {
    const { setIsChatOpen } = useChatOpen();
    const { sendMessage } = useSharedChat();

    if (!field?.ai_explainable) return null;

    const handleExplain = () => {
        const fieldLabel = field.display_name || name || field.name || '';
        const selected = field.currentValue?.value || field.value?.value || field.default || '';
        const base = `Explain the "${fieldLabel}" field and how to use it`;
        const message = (field.type === 'enum' && selected)
            ? `${base}, in particular the option "${selected}", and the calculation logic it applies.`
            : `${base}.`;
        setIsChatOpen(true);
        sendMessage(message);
    };

    return (
        <button
            type="button"
            onClick={handleExplain}
            className="ml-1 p-1 rounded hover:bg-slate-100 transition-colors"
            title="Explain this field with the AI assistant"
        >
            <span className="material-symbols-outlined text-[18px] text-slate-400">help_outline</span>
        </button>
    );
}
